module.exports = __webpack_public_path__ + "img/39.5.COD.048861ad.png";